/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '../../assets/css/bootstrap.min.css.shim.ngstyle';
import * as import1 from './scss/checkout.css.shim.ngstyle';
import * as import2 from './scss/aboutus.css.shim.ngstyle';
import * as import3 from './scss/buttons.css.shim.ngstyle';
import * as import4 from './scss/dedicated-servers-configurator.css.shim.ngstyle';
import * as import5 from './scss/header-configurator.css.shim.ngstyle';
import * as import6 from './scss/mixins.css.shim.ngstyle';
import * as import7 from './scss/services.css.shim.ngstyle';
import * as import8 from '@angular/core';
import * as import9 from '@angular/common';
import * as import10 from '../../../app/service/service-offer-payment.component';
import * as import11 from '../../../app/services/local-storage.service';
const styles_ServiceOfferPaymentComponent:any[] = [
  import0.styles,
  import1.styles,
  import2.styles,
  import3.styles,
  import4.styles,
  import5.styles,
  import6.styles,
  import7.styles
]
;
export const RenderType_ServiceOfferPaymentComponent:import8.RendererType2 = import8.ɵcrt({
  encapsulation: 0,
  styles: styles_ServiceOfferPaymentComponent,
  data: {}
}
);
function View_ServiceOfferPaymentComponent_1(l:any):import8.ɵViewDefinition {
  return import8.ɵvid(0,[
      (l()(),import8.ɵeld(0,(null as any),(null as any),58,'div',[[
        'class',
        'container checkout-payments'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n            '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),7,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'col-md-12'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Wybierz sposób płatności:'])),
    (l()(),import8.ɵted((null as any),['\n                '])),
    (l()(),import8.ɵted((null as any),['\n            '])),
    (l()(),import8.ɵted((null as any),['\n            '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),46,'div',[[
        'class',
        'row choose-payment-row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),19,'div',[[
        'class',
        'col-lg-6 col-md-6 col-sm-6'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Przelew tradycyjny'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),5,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Data Space Sp. z o.o.'])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),[' Włocławska 161'])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),[' 87-100 Toruń'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),3,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Nr konta'])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),0,'br',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),[' 95 1050 1979 1000 0090 8018 9450'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),[
      'Tytułem: ',
      ''
    ]
    )),
    (l()(),import8.ɵted((null as any),['\n                '])),
    (l()(),import8.ɵted((null as any),['\n                '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),22,'div',[[
        'class',
        'col-lg-6 col-md-6 col-sm-6 text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'h3',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Płatność z PayU'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),4,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'button-payu'
      ]
      ,
      [
        'style',
        'border-style:none'
      ]

    ]
      ,[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Płacę teraz z PayU'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'button-small'
      ]
      ,
      [
        'target',
        '_blank'
      ]

    ]
      ,[[
        8,
        'href',
        4
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Pobierz\n                            fakturę pro forma'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),4,'div',[[
        'class',
        'text-center'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n                        '])),
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'a',[
      [
        'class',
        'button-small'
      ]
      ,
      [
        'href',
        '/'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['Przejdź do panelu'])),
    (l()(),import8.ɵted((null as any),['\n                    '])),
    (l()(),import8.ɵted((null as any),['\n                '])),
    (l()(),import8.ɵted((null as any),['\n            '])),
    (l()(),import8.ɵted((null as any),['\n        ']))
  ]
  ,(null as any),(ck,v) => {
    var co:any = v.component;
    const currVal_0:any = v.context.$implicit.number;
    ck(v,31,0,currVal_0);
    const currVal_1:any = import8.ɵinlineInterpolate(1,'',v.context.$implicit.redirect,'');
    ck(v,41,0,currVal_1);
    const currVal_2:any = import8.ɵinlineInterpolate(2,'',co.invoiceStorageURL,'/invoice/',v.context.$implicit.access_token,'');
    ck(v,47,0,currVal_2);
  });
}
export function View_ServiceOfferPaymentComponent_0(l:any):import8.ɵViewDefinition {
  return import8.ɵvid(0,[
    (l()(),import8.ɵeld(0,(null as any),(null as any),7,'div',[
      [
        'class',
        'page-wrapper'
      ]
      ,
      [
        'style',
        'width: 100vw'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n    '])),
      (l()(),import8.ɵeld(0,(null as any),(null as any),4,'section',[[
        'class',
        'configuration-container checkout-configuration-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import8.ɵted((null as any),['\n         '])),
    (l()(),import8.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ServiceOfferPaymentComponent_1)),
    import8.ɵdid(802816,(null as any),0,import9.NgForOf,[
      import8.ViewContainerRef,
      import8.TemplateRef,
      import8.IterableDiffers
    ]
      ,{ngForOf: [
        0,
        'ngForOf'
      ]
    },(null as any)),
    (l()(),import8.ɵted((null as any),['\n    '])),
    (l()(),import8.ɵted((null as any),['\n'])),
    (l()(),import8.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import10.ServiceOfferPaymentComponent = v.component;
    const currVal_0:any = co.paymentInfo;
    ck(v,5,0,currVal_0);
  },(null as any));
}
function View_ServiceOfferPaymentComponent_Host_0(l:any):import8.ɵViewDefinition {
  return import8.ɵvid(0,[
    (l()(),import8.ɵeld(0,(null as any),(null as any),1,'app-service-offer-payment',([] as any[]),(null as any),(null as any),(null as any),View_ServiceOfferPaymentComponent_0,RenderType_ServiceOfferPaymentComponent)),
    import8.ɵdid(114688,(null as any),0,import10.ServiceOfferPaymentComponent,[import11.LocalStorageService],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServiceOfferPaymentComponentNgFactory:import8.ComponentFactory<import10.ServiceOfferPaymentComponent> = import8.ɵccf('app-service-offer-payment',import10.ServiceOfferPaymentComponent,View_ServiceOfferPaymentComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/service/service-offer-payment.component.ngfactory.ts